var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Arrow / Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule-/-Admin-/-Grid-view-/-Following-day",
    transform: "translate(-28.000000, -450.000000)",
    fill: "#3E82FF",
    stroke: "#3E82FF",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(26.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Arrow-/-Blue",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9812507,9.8875 C11.0395843,9.94583362 11.0687507,10.0333327 11.0687507,10.15 C11.0687507,10.2666673 11.0395843,10.3541664 10.9812507,10.4125 C8.44373797,12.7166782 7.16041747,13.8833332 7.13125066,13.9125 C7.07291703,13.9708336 6.98541791,14 6.86875066,14 C6.75208341,14 6.66458428,13.9708336 6.60625066,13.9125 L2.75625066,10.4125 C2.58124978,10.2374991 2.58124978,10.0625009 2.75625066,9.8875 C2.93125153,9.71249912 3.10624978,9.71249912 3.28125066,9.8875 L6.51875066,12.81875 L6.51875066,0.35 C6.51875066,0.1166655 6.63541616,0 6.86875066,0 C7.10208516,0 7.21875066,0.1166655 7.21875066,0.35 L7.21875066,12.81875 L10.4562507,9.8875 C10.6312515,9.71249912 10.8062498,9.71249912 10.9812507,9.8875 Z",
    id: "ion-ios-arrow-thin-down---Ionicons"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.e892f21bc1d97e94e5888c927f5c5db3.svg";
export { ForwardRef as ReactComponent };